export function getCultureFromPage() {
  return document.querySelector('#lng').value;
}

export function getNodeIdFromPage() {
  return document.querySelector('#hdnNodeId').value;
}

/** Check if we are running internet explorer. */
export function isIE() {
  let msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);

  if (Number.isNaN(msie)) {
    msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
  }

  if (Number.isNaN(msie) || msie <= 0) {
    return false;
  }

  return true;
}

export function getCached(key) {
  try {
    const json = sessionStorage.getItem(key);
    if (json === '' || json === null || json === undefined) {
      return null;
    }
    return JSON.parse(json);
  } catch (error) {
    console.log('sessionstorage not supported');
    return null;
  }
}

export function setCached(key, object) {
  try {
    const json = JSON.stringify(object);
    sessionStorage.setItem(key, json);
  } catch (error) {
    console.log('sessionstorage not supported');
  }
}

export function clearCache(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.log('sessionstorage not supported');
  }
}

/* eslint-disable */
// This is the decompiled jQuery getOffset() function
export function getOffset(element) {
  var docElem,
    win,
    rect,
    doc,
    elem = element;

  if (!elem) {
    return;
  }

  rect = elem.getBoundingClientRect();

  // Make sure element is not hidden (display: none) or disconnected
  if (rect.width || rect.height || elem.getClientRects().length) {
    doc = elem.ownerDocument;
    win = window;
    docElem = doc.documentElement;

    return {
      top: rect.top + win.pageYOffset - docElem.clientTop,
      left: rect.left + win.pageXOffset - docElem.clientLeft,
    };
  }
}
/* eslint-enable */

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
}

export function getRandomNumber(minValue, maxValue) {
  return Math.floor(Math.random() * maxValue) + minValue;
}

/**
 * @param {Object} object
 * @param {string} key
 * @return {any} value
 */
export function getParameterCaseInsensitive(object, key) {
  if (object === null || object === undefined) {
    return undefined;
  }

  return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())];
}

export function groupBy(array, expression) {
  const map = new Map();
  Array.forEach(array, item => {
    const key = expression(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

/**
 * Open the subscription form.
 */
export async function openSubscriptionForm() {
  const signup = document.querySelector('.js-newsletter-signup');

  if (signup) {
    await smoothScroll(0, 0);

    if (!signup.classList.contains('open')) {
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      });

      signup.dispatchEvent(clickEvent);
    }
  }
}

/**
 * Scroll to position and trigger callback when reached.
 * @param {Number} top
 * @param {Number} left
 * @param {Function} callback
 * @returns {Promise}
 */
function smoothScroll(top, left, callback = null) {
  return new Promise(resolve => {
    window.scrollTo({
      top,
      left,
      behavior: 'smooth',
    });

    // Start loop to check scroll position.
    checkScrollPosition();

    /**
     * Check the scroll position, trigger callback when reached.
     */
    function checkScrollPosition() {
      if (window.scrollY === top && window.scrollX === left) {
        if (callback) {
          callback();
        }
        resolve();
        return;
      }

      requestAnimationFrame(checkScrollPosition);
    }
  });
}
